// extracted by mini-css-extract-plugin
export default {"text":"B6A4gLeK","check":"aVaR4HOg","increase":"oiFSml7x"};